import type { RuleThresholds } from "../types";

export const METRIC_FEATURES = [
  "cpu_percent",
  "memory_percent",
  "swap_percent",
  "loadavg_1m",
  "process_count",
  "user_process_count",
  "thread_count",
  "net_bytes_sent_per_sec",
  "net_bytes_recv_per_sec",
  "net_packets_sent_per_sec",
  "net_packets_recv_per_sec",
  "net_errin_per_sec",
  "net_errout_per_sec",
  "net_dropin_per_sec",
  "net_dropout_per_sec",
  "disk_read_bytes_per_sec",
  "disk_write_bytes_per_sec",
  "tcp_established",
  "tcp_listen",
  "tcp_syn_sent",
  "tcp_close_wait",
  "unique_remote_ports",
] as const;

export const EVENT_FEATURE_MAP: Record<string, string> = {
  process_started: "event_process_started_count",
  process_stopped: "event_process_stopped_count",
  authentication_success: "event_authentication_success_count",
  authentication_failure: "event_authentication_failure_count",
  session_started: "event_session_started_count",
  session_ended: "event_session_ended_count",
  privilege_elevation: "event_privilege_elevation_count",
  package_installed: "event_package_installed_count",
  package_removed: "event_package_removed_count",
  package_updated: "event_package_updated_count",
  collector_error: "event_collector_error_count",
};

export const EVENT_FEATURES = [
  ...Object.values(EVENT_FEATURE_MAP),
  "event_unique_processes",
  "event_unique_users",
  "event_unique_remote_sources",
  "event_total_count",
] as const;

export const COMBINED_FEATURES = [...METRIC_FEATURES, ...EVENT_FEATURES] as const;

export const DEFAULT_THRESHOLDS: RuleThresholds = {
  authentication_failure_burst: 5,
  package_change_burst: 3,
  process_start_burst: 20,
  privilege_elevation_burst: 3,
};

export const SEVERITY_RANK = {
  informational: 0,
  low: 1,
  medium: 2,
  high: 3,
  critical: 4,
} as const;

export const TARGET_WINDOWS = 10_080;
export const MINIMUM_WINDOWS = 1_440;
